import { allRoutes } from '../../../../../utils/routeConstants';
import { NavLink, useNavigate } from 'react-router-dom';
import {Form, Formik, useFormikContext} from 'formik';
import {useEffect, useRef, useState} from 'react';
import {Modal} from 'react-bootstrap';
import Button from '../../../../../components/form/button/button';
import QRCode from "react-qr-code";
import {BarChart} from '@mui/x-charts/BarChart';
import {
  eventRowInfoIconEnum
} from '../../../../../utils/constants';
import SingleSelectDropdown from '../../../../../components/form/singleSelectDropdown/singleSelectDropdown';
import {assets} from '../../../../../utils/assetsSrc';
import {useLocation} from 'react-router-dom';
import * as Yup from 'yup';
import './anonymousScoring.scss';
import {useDispatch, useSelector} from 'react-redux';
import {getAllRiskAssessmentStateSelector} from '../../../../../redux/selectors/riskAssessment';
import {apiFunctions} from '../../../../../api/functions';
import {toast} from 'react-toastify';
import TextArea from '../../../../../components/form/textArea/TextArea';
import localStorage from 'redux-persist/es/storage';
import { fetchVotes } from '../../../../../redux/anonymous-scoring/anonymousScoringSlice';
import { 
  getSessionIdSelector, 
  getSessionActiveSelector, 
  getVotesSelector, 
  getStoredVotesSelector, 
  getProtectiveMeasuresSelector,
  getErrorSelector,
  getAnonymousScoringLoadingState 
} from '../../../../../redux/selectors/anonymousScoringSelector';
import { 
  startSessionRequest, 
  fetchResultsRequest, 
  stopSessionRequest, 
  saveVotingDataRequest, 
  getVotingDataRequest,
  getProtectiveMeasuresRequest,
  clearVotingDataRequest 
} from '../../../../../redux/anonymous-scoring/anonymousScoringSlice';

export default function AnonymousScoring({
  label,
  show,
  setShow,
  data,
  parentNoteValue
}) {
  const nav = useNavigate();
  const [isScoring, setIsScoring] = useState(false);
  const [shouldShowResults, setShouldShowResults] = useState(false);
  const dispatch = useDispatch();
  const sessionId = useSelector(getSessionIdSelector());
  const isSessionActive = useSelector(getSessionActiveSelector());
  const votes = useSelector(getVotesSelector());
  const retrievedVotes = useSelector(getStoredVotesSelector());
  const eventAssessmentProtectiveMeasures = useSelector(getProtectiveMeasuresSelector());
  const isLoading = useSelector(getAnonymousScoringLoadingState());
  const [currentView, setCurrentView] = useState('Score');

  let currentVotesSubmitted = votes['likelihood_results']
    ? Object.values(votes['likelihood_results']).reduce((sum, value) => sum + value, 0)
    : 0;
  
  let likelihoodScores = [
    {id: 1, name: 'Rare', score: votes['likelihood_results']?.[1] || 0},
    {id: 2, name: 'Unlikely', score: votes['likelihood_results']?.[2] || 0},
    {id: 3, name: 'Possible', score: votes['likelihood_results']?.[3] || 0},
    {id: 4, name: 'Likely', score: votes['likelihood_results']?.[4] || 0},
    {id: 5, name: 'Almost Certain', score: votes['likelihood_results']?.[5] || 0}
  ]
  let severityScores = [
    {id: 1, name: 'Minor', score: votes['severity_results']?.[1] || 0},
    {id: 2, name: 'Medium', score: votes['severity_results']?.[2] || 0},
    {id: 3, name: 'Serious', score: votes['severity_results']?.[3] || 0},
    {id: 4, name: 'Major', score: votes['severity_results']?.[4] || 0},
    {id: 5, name: 'Catastrophic', score: votes['severity_results']?.[5] || 0}
  ]
  let retrievedLikelihoodResults = retrievedVotes.likelihood_results;
  let retrievedSeverityResults = retrievedVotes.severity_results;
  let likelihoodStoredScores = [
    {id: 1, name: 'Rare', score: retrievedLikelihoodResults?.[1] || 0},
    {id: 2, name: 'Unlikely', score: retrievedLikelihoodResults?.[2] || 0},
    {id: 3, name: 'Possible', score: retrievedLikelihoodResults?.[3] || 0},
    {id: 4, name: 'Likely', score: retrievedLikelihoodResults?.[4] || 0},
    {id: 5, name: 'Almost Certain', score: retrievedLikelihoodResults?.[5] || 0}
  ]
  let severityStoredScores = [
    {id: 1, name: 'Minor', score: retrievedSeverityResults?.[1] || 0},
    {id: 2, name: 'Medium', score: retrievedSeverityResults?.[2] || 0},
    {id: 3, name: 'Serious', score: retrievedSeverityResults?.[3] || 0},
    {id: 4, name: 'Major', score: retrievedSeverityResults?.[4] || 0},
    {id: 5, name: 'Catastrophic', score: retrievedSeverityResults?.[5] || 0}
  ]
  let likelihoodStoredNote = retrievedVotes['likelihood_scoring_note'] || '';
  let severityStoredNote = retrievedVotes['severity_scoring_note'] || '';
  let inherently_measures = eventAssessmentProtectiveMeasures['inherently_measures'] || 'None';
  let safeguarding = eventAssessmentProtectiveMeasures['safeguarding'] || 'None';
  let info_for_use = eventAssessmentProtectiveMeasures['info_for_use'] || 'None';

  const likelihoodData = {
    labels: likelihoodScores.map(item => item.name),
    datasets: [
      {
        data: likelihoodScores.map(item => item.score),
      },
    ],
  }
  const severityData = {
    labels: severityScores.map(item => item.name),
    datasets: [
      {
        data: severityScores.map(item => item.score),
      },
    ],
  }
  const likelihoodStoredScoreData = {
    labels: likelihoodStoredScores.map(item => item.name),
    datasets: [
      {
        data: likelihoodStoredScores.map(item => item.score),
      },
    ],
  }
  const severityStoredScoreData = {
    labels: severityStoredScores.map(item => item.name),
    datasets: [
      {
        data: severityStoredScores.map(item => item.score),
      },
    ],
  }

  const [loading, setLoading] = useState(false);
  const [taskList, setTaskList] = useState([]);
  const riskAssessmentState = useSelector(getAllRiskAssessmentStateSelector());
  const [riskAssessmentList, setriskAssessmentList] =
    useState(riskAssessmentState);

  useEffect(() => {
    dispatch(getProtectiveMeasuresRequest(data.id)); // Fetch protective measures
  }, []);
  
  useEffect(() => {
    let interval;
    if (sessionId && isSessionActive) {
      interval = setInterval(() => {
        dispatch(fetchResultsRequest(sessionId));
      }, 1000);
    }
    return () => clearInterval(interval); // Cleanup the interval on component unmount
  }, [sessionId, isSessionActive]);

  const initialValues = {
    riskAssessment: undefined,
    task: undefined,
    likelihood_note: '',
    severity_note: '',
  };

  const validate = Yup.object({
    riskAssessment: Yup.string().required('Risk Assessment is Required'),
    task: Yup.object().required('Task is Required'),
  });

  const encodedEventName = data.event_detail.name.replace(/ /g, '-');
  const qrCodeURL = `${window.location.origin}${allRoutes.dashboardRoutes.assessmentRoutes.anonymousScoringEvent}?sessionId=${sessionId}&eventName=${encodedEventName}`;

  const handleStartScoring = () => {
    dispatch(startSessionRequest());
    setIsScoring(true);
    setShouldShowResults(false);
  };

  const handleStopScoring = (stopButtonClicked) => {
    if (!stopButtonClicked) { setShow(false); }
    dispatch(stopSessionRequest(sessionId));
    setIsScoring(false);
    setShouldShowResults(true);
  };

  const handleClearStoredScores = () => {
    dispatch(clearVotingDataRequest(data.id)); // Dispatch the action to clear voting data
  }

  const handleScoreFullSubmit = (values) => {
    const likelihood_results = JSON.stringify(votes.likelihood_results);
    const severity_results = JSON.stringify(votes.severity_results);
    const payload = {
      event_task_id: data.id, // Use event_task_id here
      likelihood_results: likelihood_results,
      severity_results: severity_results,
      likelihood_scoring_note: values.likelihood_scoring_note,
      severity_scoring_note: values.severity_scoring_note,
    };
    dispatch(saveVotingDataRequest(payload));
  };

  const handleScoreNoteSubmit = (values) => {
    const payload = {
      event_task_id: data.id, // Use event_task_id here
      likelihood_scoring_note: values.likelihood_scoring_note,
      severity_scoring_note: values.severity_scoring_note,
    };
    dispatch(saveVotingDataRequest(payload));
  };

  const handleSwitchToSavedScore = () => {
    setCurrentView('Saved Score'); // Switch to "Saved Score" view
    dispatch(getVotingDataRequest(data.id)); // Fetch saved voting data
  };

  const handleSwitchToScore = () => {
    setCurrentView('Score'); // Switch back to "Score" view
    setShouldShowResults(false); // Reset the show results state
  };

  return (
    <Modal
      show={show}
      onHide={() => handleStopScoring(false)}
      aria-labelledby="anonymous-scoring"
      centered
      className="anonymous-scoring">
      {currentView === 'Score' && (
        <Modal.Body className="p-5 px-5 text-center">
          <div className="header">
            <p className="label mt-3 mb-4">{label}</p>
            <img onClick={() => handleStopScoring(false)} src={assets.closeIcon} />
          </div>
          <div>
            <h3>Event: {data.event_detail.name}</h3>
            <br/>
            <h4>Note: {parentNoteValue}</h4>
            <br/>
            <h4>Protective Measures:</h4>
            <h5>Inherently Safe Design Measures:</h5>
            <h6>{inherently_measures}</h6>
            <h5>Safeguarding:</h5>
            <h6>{safeguarding}</h6>
            <h5>Info for Use:</h5>
            <h6>{info_for_use}</h6>
          </div>
          <hr/>
          <div>
            {!isScoring && !shouldShowResults && (
              <div>
                <h4>Start to begin a voting session</h4>
              </div>
            )}
            {isScoring && (
              <div>
                <div>
                  {<h4>Votes Submitted: {currentVotesSubmitted} </h4>}
                </div>
                <br/>
                <div style={{ height: "auto", margin: "0 auto", maxWidth: 256, width: "100%" }}>
                  <QRCode
                    size={256}
                    style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                    value={qrCodeURL}
                    viewBox={`0 0 256 256`}
                  />
                </div>
                <br/>
              </div>
            )}
            {shouldShowResults && isLoading && <p>Loading...</p>}
            {shouldShowResults && !isLoading && (
              <div>
                <div>
                  <h3>Voting Results</h3>
                  <br/>
                  {<h4>Votes Submitted: {currentVotesSubmitted} </h4>}
                  <br/>
                </div>
                <h4>Likelihood Scores</h4>
                <BarChart
                  series={[
                    { data: likelihoodData.datasets[0].data, name: 'Likelihood' },
                  ]}
                  height={290}
                  xAxis={[{ 
                    data: likelihoodData.labels, 
                    label: 'Likelihood',
                    scaleType: 'band' 
                  }]}
                  yAxis={[
                    {
                      label: 'Score',
                    },
                  ]}
                  xAxisLabel="Likelihood"
                  yAxisLabel="Score"
                  margin={{ top: 10, bottom: 50, left: 40, right: 10 }}
                />
                <h4>Severity Scores</h4>
                <BarChart
                  series={[
                    { data: severityData.datasets[0].data, name: 'Severity' },
                  ]}
                  height={290}
                  xAxis={[{ 
                    data: severityData.labels,
                    label: 'Severity',
                    scaleType: 'band' }]}
                  yAxis={[
                    {
                      label: 'Score',
                    },
                  ]}
                  xAxisLabel="Severity"
                  yAxisLabel="Score"
                  margin={{ top: 10, bottom: 50, left: 40, right: 10 }}
                />
              </div>
            )}
          </div>
          <br/>
          <Formik
            initialValues={initialValues}
            validationSchema={validate}
            onSubmit={handleScoreFullSubmit}>
            {({
              formik,
              values,
              setFieldValue,
              isSubmitting,
              isValid,
              errors,
              touched,
            }) => (
              <Form>
                <div>
                  <TextArea 
                    label="Likelihood Scoring Notes (optional)"
                    name="likelihood scoring notes"
                    value={values['likelihood_scoring_note']}
                    onChange={(e) => setFieldValue('likelihood_scoring_note', e.target.value)}
                  />
                  <TextArea 
                    label="Severity Scoring Notes (optional)"
                    name="severity scoring notes"
                    value={values['severity_scoring_note']}
                    onChange={(e) => setFieldValue('severity_scoring_note', e.target.value)}
                  />
                </div>
                <div className="action-buttons">
                  <Button type="button" clickHandler={handleStartScoring} variant="secondary-button">
                    Start
                  </Button>
                  <Button type="button" clickHandler={() => handleStopScoring(true)} disabled={!isScoring} variant="secondary-button">
                    Stop
                  </Button>
                  <Button type="button" clickHandler={() => handleScoreFullSubmit(values)} variant="submit-button">
                    Save
                  </Button>
                </div>
                <br/>
                <div className="action-buttons">
                  <Button type="button" clickHandler={handleSwitchToSavedScore} variant="secondary-button">
                    View Saved Score
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      )}
      {currentView === 'Saved Score' && (
        <Modal.Body className="p-5 px-5 text-center">
          <div className="header">
            <p className="label mt-3 mb-4">{label}</p>
            <img onClick={() => setShow(false)} src={assets.closeIcon} />
          </div>
          <div>
            <h3>Event: {data.event_detail.name}</h3>
            <br/>
            <h4>Note: {parentNoteValue}</h4>
            <br/>
            <h4>Protective Measures:</h4>
            <h5>Inherently Safe Design Measures:</h5>
            <h6>{inherently_measures}</h6>
            <h5>Safeguarding:</h5>
            <h6>{safeguarding}</h6>
            <h5>Info for Use:</h5>
            <h6>{info_for_use}</h6>
          </div>
          <hr/>
          {Object.keys(retrievedVotes).length === 0 ? (
            <div>
              <h3>No Saved Score</h3>
              <h4>Score this event and Save results to view here</h4>
              <div className="action-buttons">
                <Button type="button" clickHandler={handleSwitchToScore} variant="secondary-button">
                  Back to Scoring
                </Button>
              </div>
            </div>
          ) : (
            <div>
              <h3>Saved Score</h3>
              <br/>
              <h4>Likelihood Scores</h4>
              <BarChart
                  series={[
                    { data: likelihoodStoredScoreData.datasets[0].data, name: 'Likelihood' },
                  ]}
                  height={290}
                  xAxis={[{ 
                    data: likelihoodStoredScoreData.labels, 
                    label: 'Likelihood',
                    scaleType: 'band' 
                  }]}
                  yAxis={[
                    {
                      label: 'Score',
                    },
                  ]}
                  xAxisLabel="Likelihood"
                  yAxisLabel="Score"
                  margin={{ top: 10, bottom: 50, left: 40, right: 10 }}
                />
              <h4>Severity Scores</h4>
              <BarChart
                  series={[
                    { data: severityStoredScoreData.datasets[0].data, name: 'Severity' },
                  ]}
                  height={290}
                  xAxis={[{ 
                    data: severityStoredScoreData.labels,
                    label: 'Severity',
                    scaleType: 'band' }]}
                  yAxis={[
                    {
                      label: 'Score',
                    },
                  ]}
                  xAxisLabel="Severity"
                  yAxisLabel="Score"
                  margin={{ top: 10, bottom: 50, left: 40, right: 10 }}
                />
              <br/>
              <Formik
                initialValues={initialValues}
                validationSchema={validate}
                onSubmit={handleScoreNoteSubmit}>
                {({
                  formik,
                  values,
                  setFieldValue,
                  isSubmitting,
                  isValid,
                  errors,
                  touched,
                }) => (
                <Form>
                  <div>
                    <TextArea 
                      label="Likelihood Saved Scoring Notes"
                      name="likelihood scoring notes"
                      defaultValue={likelihoodStoredNote}
                      onChange={(e) => setFieldValue('likelihood_scoring_note', e.target.value)}
                    />
                    <TextArea 
                      label="Severity Saved Scoring Notes"
                      name="severity scoring notes"
                      defaultValue={severityStoredNote}
                      onChange={(e) => setFieldValue('severity_scoring_note', e.target.value)}
                    />
                  </div>
                  <div className="action-buttons">
                    <Button type="button" clickHandler={handleClearStoredScores} variant="submit-button">
                      Clear (Deletes saved scores and notes)
                    </Button>
                    <Button type="button" clickHandler={() => handleScoreNoteSubmit(values)} variant="submit-button">
                      Save
                    </Button>
                  </div>
                  <br/>
                  <div className="action-buttons">
                    <Button type="button" clickHandler={handleSwitchToScore} variant="secondary-button">
                      Back to Scoring
                    </Button>
                  </div>
                </Form>
                )}
              </Formik>
            </div>
          )}
          
        </Modal.Body>
      )}
    </Modal>
  );
}
